import { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const QrIcon: FC<SvgProps> = ({ fill, ...props }) => {
    const color = fill || 'currentColor'

    return (
        <Svg viewBox="0 0 20 20" width={20} height={20} fill="none" {...props}>
            <Path
                fill={color}
                d="M2.98 17h6.483v-6.38H2.98zm1.221-5.159h4.04v3.938h-4.04zM2.98 9.38h6.483V3H2.98zM4.201 4.22h4.04v3.938h-4.04zM10.535 3v6.38h6.482V3zm5.261 5.159h-4.04V4.22h4.04zM14.461 15.715h-1.266v1.266h1.266zM16.992 15.715h-1.265v1.266h1.265z"
            />
            <Path
                fill={color}
                d="M15.724 11.911h-2.532v-1.265H10.68V17h1.246v-1.285h1.266V14.45h-1.266v-1.272h2.532v1.266h2.531v-3.797h-1.266zM14.461 5.557h-1.266v1.266h1.266zM6.852 5.557H5.586v1.266h1.266zM6.852 13.177H5.586v1.266h1.266z"
            />
        </Svg>
    )
}

export default QrIcon
